import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class DropZone extends Component {
  constructor() {
    super();
    this.onDrop = (files) => {
      this.setState({files});
      this.props.getFile(files);
    };
    this.state = {
      files: []
    };
  }
  clearFiles = () =>{
      this.setState({files:[]});
  }

  render() {
    const files = this.state.files.map(file => (
      <div key={file.name}>
        {file.name}{/*file.size*/}
      </div>
    ));

    return (
      <Dropzone onDrop={this.onDrop} maxFiles={1}>
        {({getRootProps, getInputProps}) => (
          <section className="dropzone-container">
            <div {...getRootProps({className: 'dropzone'})}>
              <input {...getInputProps()} />
              {this.state.files.length>0?<div className="drop-list">{files}</div>:<p>Click or Drag 'n' drop some files here</p>}
            </div>
            {this.state.files.length>0?<div className="action"><FontAwesomeIcon onClick={this.clearFiles.bind()} icon="times"/></div>:null}
          </section>
        )}
      </Dropzone>
    );
  }
}
export default (DropZone);
